// extracted by mini-css-extract-plugin
module.exports = {"alertWarning":"alert_alertWarning__2jNbP","alertLink":"alert_alertLink__3qt9J"};